import { z } from 'zod';

/////////////////////////////////////////
// CORE COMMUNICATION FACEBOOK INTEGRATION PAGE SCHEMA
/////////////////////////////////////////

export const CoreCommunicationFacebookIntegrationPageSchema = z.object({
  id: z.bigint(),
  integrationId: z.bigint(),
  cityId: z.number().int(),
  facebookPageId: z.string(),
  facebookPageName: z.string(),
})

export type CoreCommunicationFacebookIntegrationPage = z.infer<typeof CoreCommunicationFacebookIntegrationPageSchema>

export default CoreCommunicationFacebookIntegrationPageSchema;
